/**
 * DialogBlock
 */
import clsx from 'clsx';
import React from 'react';
import { AvatarImage } from 'ui-component-library/base';
/** Main description for this component. */
var DialogBlock = function (_a) {
    var className = _a.className, image = _a.image, name = _a.name, title = _a.title, published = _a.published, updated = _a.updated, isOrganizationReply = _a.isOrganizationReply, children = _a.children;
    return (React.createElement("article", { "data-cid": "DialogBlock", className: clsx(className, 'relative bg-greyLightest p-4 lg:px-11 lg:py-12 rounded-2xl ml-6 lg:ml-4 xl:ml-0') },
        React.createElement("div", { className: "absolute left-0 lg:-ml-8 lg:-mt-6 hidden lg:block" },
            React.createElement(AvatarImage, { image: image, uhmIcon: isOrganizationReply })),
        React.createElement("div", { className: "absolute left-0 -ml-6 -mt-1 block lg:hidden" },
            React.createElement("div", { className: "relative w-8 h-8" },
                React.createElement("div", { className: "image__object-fit w-full h-full border border-greySemiLight rounded-full mr-3" },
                    React.createElement("img", { height: "30", width: "30", src: image + '?width=30', alt: "", className: "mb-0" })))),
        children,
        React.createElement("div", { className: "mt-7" },
            React.createElement("h2", { className: "text-h3" }, name),
            title && (React.createElement("p", { className: "text-h5 text-greyDarker leading-6 mb-5" }, title)),
            React.createElement("p", { className: "text-h5 text-greyDarker leading-6" },
                published,
                updated && " (Uppdaterat " + updated + ")"))));
};
export default DialogBlock;
